import { Country, CountryData } from '../types'

export function getCountryList(data: any[] | undefined, year?: number) {
  const yearToFilter = year || 2020

  // Filter data for the specified year
  const filteredData = data?.filter((entry: any) => entry.PublishYear === yearToFilter.toString())

  // Extract country code and name pairs
  const countryList = filteredData?.map((entry: any) => ({ [entry.Code]: entry.CountryName }))

  return countryList || []
}

export function getCountryData(countryData: Country[]) {
  const countryDataList = countryData
    .map(({ countryName, countryCode, countryLongCode, isAdhocCountry }) => ({
      countryName,
      countryCode,
      countryLongCode,
      isAdhocCountry: isAdhocCountry || false,
    }))
    .filter(({ countryCode, countryLongCode }) => !!countryCode && !!countryLongCode)
  return countryDataList
}

export const getCountryNameByCode = (countryCode: string, countryDataList: CountryData[]) => {
  const foundCountry = countryDataList?.find((country) => country.countryLongCode === countryCode)
  return foundCountry ? foundCountry.countryName : null
}

export const getCountryNameByShortCode = (countryCode: string, countryDataList: CountryData[]) => {
  const foundCountry = countryDataList?.find((country) => country.countryCode === countryCode)
  return foundCountry ? foundCountry.countryName : null
}

export const getCountryCodeByName = (countryName: string, countryDataList: CountryData[]) => {
  const foundCountry = countryDataList?.find((country) => country.countryName === countryName)

  return foundCountry ? foundCountry.countryLongCode : null
}
